import React from 'react'
import { ViewPropTypes, View, TouchableOpacity, Platform, Dimensions } from 'react-native'
import PropTypes from 'prop-types'
import ContentLoader, { Rect } from 'react-content-loader/native'

import { Icon } from '@vfgroup-oneplatform/foundation/Components'

import { LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import styles from './ButtonGroup.Styles'


const LoadingContent = (props) => {
    return <View style={[styles.option(props.theme), props.style]} >
        <ContentLoader
            speed={2}
            width={100}
            height={40}
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
        >
            <Rect x="0" y="3" rx="6" ry="6" width="100" height="15" />
            <Rect x="10" y="26" rx="6" ry="6" width="80" height="12" />
        </ContentLoader>
    </View>
}

LoadingContent.propTypes = {
    style: PropTypes.object,
    theme: PropTypes.object,
}

function ButtonGroup(props) {

    const {
        options,
        style,
        containerStyle,
        optionStyle,
        activeOptionStyle,
        selected,
        setSelected,
        isLoading,
        onPress,
        theme,
    } = props

    return (
        <View style={[{ height: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 70 : 50 }, containerStyle]}>
            <View style={[styles.container, style]}>
                {isLoading
                    ? <>
                        <LoadingContent style={styles.firstLoader} theme={theme} />
                        <LoadingContent style={styles.lastLoader} theme={theme} />
                    </>
                    : options.map((item, index) => {
                        const active = item.screenName === selected
                        const itemStyle = {}
                        if (index === options.length - 1) {
                            itemStyle.borderRightWidth = 0
                        }
                        return (
                            <TouchableOpacity
                                disabled={item?.disabled}
                                onPress={() => onPress(item.screenName)}
                                style={[
                                    styles.option(theme),
                                    optionStyle,
                                    active && styles.activeoption,
                                    active && activeOptionStyle,
                                    item?.disabled && styles.disabled,
                                    itemStyle,
                                ]}
                            >
                                <Icon
                                    name={item.image}
                                    size={24}
                                    type="image"
                                    resizeMode="contain"
                                    style={[
                                        styles.icon(theme),
                                        active && styles.activeIcon,
                                        item?.disabled && styles.disabledIcon,
                                    ]}
                                />
                            </TouchableOpacity>
                        )
                    })}
            </View>
        </View>
    )
}

ButtonGroup.defaultProps = {
    options: [{}, {}],
    style: {},
    containerStyle: {},
    optionStyle: {},
    activeOptionStyle: {},
    selected: -1,
    setSelected: () => { },
    isLoading: false,
    theme: {
        name: 'light',
        colors: LightThemeColors
    },
}

ButtonGroup.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.string,
            disabled: PropTypes.bool,
        })
    ),
    style: ViewPropTypes.style,
    containerStyle: PropTypes.object,
    optionStyle: PropTypes.object,
    activeOptionStyle: PropTypes.object,
    selected: PropTypes.number,
    setSelected: PropTypes.func,
    isLoading: PropTypes.bool,
    onPress: PropTypes.func,
    theme: PropTypes.object,
}

export default ButtonGroup
